import { notification } from 'antd';

export const validateCustomer = (customerId: number) => {
    if (!customerId || customerId === -1) {
        notification.error({
            message: 'Customer ID not valid!',
            description: 'Unable to retrieve products data cause selected customer is not valid.',
            duration: 2
        });
    }
}